<script setup>
const currentStep = defineModel();

defineProps({
	values: Array,
	disabled: Boolean,
})
</script>

<template>
	<div class="switcher-wr">
		<button
			class="switcher__item"
			:class="{'switcher__item--active': currentStep == values[0]}"
			:disabled
			@click="currentStep = values[0]"
		>
			<slot name="btn-1" />
		</button>
		<button
			class="switcher__item"
			:class="{'switcher__item--active': currentStep == values[1]}"
			:disabled
			@click="currentStep = values[1]"
		>
			<slot name="btn-2" />
		</button>
		<div
			class="switch-tube"
			:style="`transform: TranslateX(${100 * values.indexOf(currentStep)}%)`"
		/>
	</div>
</template>

<style lang="scss">
.switcher-wr {
	display: flex;
	height: fit-content;
	padding: 6px;
	border-radius: 12px;
	background-color: #f9f9f9;
	position: relative;

	.switch-tube {
		width: calc(50% - 6px);
		height: 32px;
		position: absolute;
		top: 6px;
		background-color: $yellow;
		border-radius: 8px;
		transition: 0.3s ease-in-out;
	}

	.switcher__item {
		padding-inline: 25.5px;
		height: 32px;
		position: relative;
		z-index: 1;
		color: #9d9e9e;
		font-family: 'Raleway';

		span { transition: 0.3s ease-in-out }

		&--active { color: #fff }
	}
}
</style>
